import { useEffect } from "react";
import React from "react";
import { TriggeredHook } from "sonobello.utilities.react";

import { Token } from "../../../../Models/Authentication";
import IAuthorizationStepProps from "../../Types/IAuthorizationStepProps";
import ISsoAuthorizationFormProps from "../../Types/ISsoAuthorizationForm";
import { ILoginStepProps } from "../LoginProcess";

export interface IOAuthLoginStepProps {
  /** The hook which obtains the auth token using OAuth. */
  useGetOAuthToken: TriggeredHook<Token, undefined, string>;
  /** The form that the user should interact with for this step. */
  LoginForm: React.FC<ISsoAuthorizationFormProps>;
}

const SsoAuthenticationStep: React.FC<IOAuthLoginStepProps & IAuthorizationStepProps<Token> & ILoginStepProps> = ({
  isIdentityReady,
  onComplete,
  setAuthorization,
  useGetOAuthToken,
  LoginForm
}) => {
  const { result, execute, error, ...rest } = useGetOAuthToken();

  useEffect(() => {
    if (isIdentityReady) onComplete();
  }, [isIdentityReady]);

  useEffect(() => {
    if (result) setAuthorization(result);
  }, [result]);

  return LoginForm({ onClick: execute, label: null, errorMessage: error, ...rest });
};

export default SsoAuthenticationStep;
